var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":_vm.size,"height":_vm.size}},[_c('g',{attrs:{"transform":_vm.translate}},[_c('path',{style:(_vm.style),attrs:{"id":_vm.pathId,"d":_vm.pathD,"stroke-width":_vm.strokeWidth,"stroke":_vm.stroke,"fill":"none"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3430d79a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpiralPath.vue
// module id = null
// module chunks = 